export default {
    title: 'code',
    icon: 'Code',
    description: 'Code',
    action: [ 'formatBlock', 'pre' ],
};
